
import { loadScript } from "../../../globals/constants";
import SEO from "../seo";
import { useEffect, useState } from "react";
import { getServicePage } from "../../../utils/func";
import PageBody from "../pageBody";

function ServicePage({
    siteName,
    pageTitle
}) {

    const [pageInfo,setPageInfo] = useState(null)


    useEffect(() => {
        
        getServicePage().then(result => {
            console.log('service page is', result)
            setPageInfo(result[0])
        }).catch(err => {

        })
    }, [])

  
    useEffect(() => {
        loadScript("js/custom.js");
    })


    return (
        <>
            <SEO 
                siteName={siteName}
                pageTitle={pageTitle || pageInfo?.name}
                description=""
                keywords=""
            />

         {/* Why Choose us */}
         {/* <SectionHome3WhyChooseUs /> */}

            {
                pageInfo && pageInfo?.body && (
                    <PageBody 
                        body={JSON.parse(pageInfo?.body)}
                        formspree_id={""}
                    />
                )
            }
    
        </>
    )
}
export default ServicePage;